<template>
  <notifications />
</template>

<script>
import Notifications from '@/components/Reports/Notifications'

export default {
  components: {
    Notifications
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Notifications.vue?221b8914